import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from 'lib/@mui';

import SelectComponent from '../../../../containers/Ezlo/EzloMeshbot/components/SelectComponent';
import { info } from '../../../../containers/Ezlo/EzloMeshbot/utils';
import { getUserCodesItem } from 'containers/Ezlo/EzloMeshbot/utils/deviceNode/getUserCodesItem';
import { buildPinCodeTriggerData } from 'containers/Ezlo/EzloMeshbot/utils/deviceNode/buildPinCodeTriggerData';
import { EMPTY_STRING } from 'constants/MeshbotConstant';
import { useTranslate } from 'features/languages';
import { EZLOGIC_ERROR_TEXT_PIN_CODE } from 'constants/language_tokens';

const SelectPinCode = ({ onDataUpdate, items, deviceId, selectedAction, selectedPinCode }) => {
    const { t } = useTranslate();
    const error = selectedPinCode === null;

    // Find the user_codes item once, then reuse it for both the dropdown list and the selection payload.
    const userCodesItem = useMemo(() => getUserCodesItem(items, deviceId), [items, deviceId]);
    const pinCodeList = useMemo(() => Object.entries(userCodesItem?.value || {}), [userCodesItem]);

    const handleSelectCapability = (event) => {
        const pinKey = event.target.value;
        onDataUpdate(buildPinCodeTriggerData(userCodesItem?._id || EMPTY_STRING, selectedAction, pinKey));
    };

    return (
        <SelectComponent
            value={selectedPinCode}
            label={info.hints.pinCode}
            onChange={handleSelectCapability}
            error={error}
            helperText={t(EZLOGIC_ERROR_TEXT_PIN_CODE)}
        >
            {pinCodeList.map(([key, value]) => (
                <MenuItem key={key} value={key}>
                    {value?.name}
                </MenuItem>
            ))}
        </SelectComponent>
    );
};

export default SelectPinCode;

SelectPinCode.propTypes = {
    deviceId: PropTypes.string,
    selectedAction: PropTypes.string,
    items: PropTypes.array,
    onDataUpdate: PropTypes.func,
    selectedPinCode: PropTypes.string,
};
